export class Service {
  static blank() {
    return new this({});
  }

  constructor(json) {
    Object.assign(this, json);
  }

  static fromServer(json) {
    return new Service({
      os: json.os || "",
      cpu: json.cpu || "",
      memory: json.rom || "",
      hardDisk: json.ram || "",
      serviceIp: json.engineIp || "",
      servicePwd: json.enginePwd || "",
      network: json.web || "",
    });
  }

  serviceId = "";
  os = "";
  cpu = "";
  memory = Number();
  hardDisk = "";
  serviceIp = "";
  servicePwd = "";
  hashPwd = "******";
  showPwd = false;
  network = "";
}
